import React from 'react';
import { Phone, MapPin, Printer, Gift, Laptop, Instagram } from 'lucide-react';
import { companyInfo } from '../utils/mockData';

const Footer = () => {
  const whatsappNumber = "5585985195369";
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  const instagramLink = "https://www.instagram.com/infortech_graficaeassistencia";

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <button 
              onClick={() => document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth' })}
              className="hover:opacity-80 transition-opacity mb-4 inline-block"
            >
              <img 
                src={companyInfo.logo.icon}
                alt="Infortech"
                className="h-16 w-auto object-contain"
              />
            </button>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Soluções completas em impressão, personalizados e assistência técnica em Fortaleza.
            </p>
            <div className="flex items-center text-sm text-gray-400 mb-2">
              <MapPin className="w-4 h-4 mr-2 flex-shrink-0" />
              <span>Fortaleza - CE</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Serviços</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex items-center hover:text-white transition-colors cursor-pointer">
                <Printer className="w-4 h-4 mr-2" />
                Gráfica Rápida
              </li>
              <li className="flex items-center hover:text-white transition-colors cursor-pointer">
                <Gift className="w-4 h-4 mr-2" />
                Personalizados
              </li>
              <li className="flex items-center hover:text-white transition-colors cursor-pointer">
                <Laptop className="w-4 h-4 mr-2" />
                Assistência Técnica
              </li>
              <li className="hover:text-white transition-colors cursor-pointer">Impressão Colorida</li>
              <li className="hover:text-white transition-colors cursor-pointer">Cartões de Visita</li>
              <li className="hover:text-white transition-colors cursor-pointer">Reparo de Notebooks</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Links Rápidos</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <button 
                  onClick={() => document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Início
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('servicos')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('sobre')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Sobre
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('galeria')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Galeria
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('avaliacoes')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Avaliações
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
                  className="hover:text-white transition-colors"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contato</h4>
            <div className="space-y-3">
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-400 hover:text-[#25D366] transition-colors text-sm group"
              >
                <div className="w-8 h-8 bg-gray-800 group-hover:bg-[#25D366] rounded-lg flex items-center justify-center mr-3 transition-colors">
                  <Phone className="w-4 h-4" />
                </div>
                <span>{companyInfo.phone}</span>
              </a>
              <div className="text-gray-400 text-sm">
                <p className="font-semibold text-white mb-1">Horário</p>
                <p>{companyInfo.hours}</p>
              </div>
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#25D366] hover:bg-[#20BD5C] text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all hover:shadow-lg mt-2"
              >
                Fale Conosco
              </a>
              <a 
                href={instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-400 hover:text-[#E1306C] transition-colors text-sm group mt-3"
              >
                <div className="w-8 h-8 bg-gray-800 group-hover:bg-gradient-to-br group-hover:from-[#F58529] group-hover:via-[#DD2A7B] group-hover:to-[#8134AF] rounded-lg flex items-center justify-center mr-3 transition-all">
                  <Instagram className="w-4 h-4" />
                </div>
                <span>@infortech_graficaeassistencia</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} {companyInfo.shortName}. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <span>Fortaleza - CE</span>
              <span>•</span>
              <span>⭐ {companyInfo.rating} de 5</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
